import { DestroyRef, Injectable } from '@angular/core';
import { UserProfileSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { WebchatService } from '@gestor-web/app/shared/components';
import { Subject, takeUntil, tap } from 'rxjs';

const ZENDESK_KEY = 'd842b49b-f66c-4495-a74d-e203dc901a03';

@Injectable({ providedIn: 'root' })
export class ZendeskScriptService {
  private initialized: boolean = false;
  private ngDestroyed$ = new Subject<void>();

  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
    private webchatService: WebchatService,
  ) {
    const unregister = this.destroyRef.onDestroy(() => {
      this.ngDestroyed$.next();
      this.ngDestroyed$.complete();
      unregister();
    });

    this.store
      .select(UserProfileSelectors.selectCookieAcceptAll)
      .pipe(
        takeUntil(this.ngDestroyed$),
        // tap(all => console.log('[Script::ZenDesk] listening cookie consent:', all)),
      )
      .subscribe(all => {
        if (all) {
          this.initZenDesk();
        }
      });
  }

  private initZenDesk() {
    // console.log('[Script::ZenDesk] initZenDesk...');
    if (this.initialized) {
      // console.log('[Script::ZenDesk] initZenDesk... skipped!');
      return;
    }

    // console.log('[Script::ZenDesk] initZenDesk... initializing!');

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.type = 'text/javascript';
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + ZENDESK_KEY;
    script.onload = () => this.webchatService.init();
    document.getElementsByTagName('head')[0].appendChild(script);

    this.initialized = true;
  }
}
